module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demos"
  }, [_c('div', {
    staticClass: "demos-content"
  }, [_c('ul', {
    staticClass: "demos-menu"
  }, [_c('li', {
    staticClass: "demos-menu-title"
  }, [_vm._v("demos")]), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-pano"
    }
  }, [_vm._v("basic panorama")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-cube-pano"
    }
  }, [_vm._v("Cube Faces")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-video-pano"
    }
  }, [_vm._v("Video Pano")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-scene"
    }
  }, [_vm._v("Scene with hotspot")])], 1), _vm._v(" "), _c('li', {
    staticClass: "demos-menu-item"
  }, [_c('router-link', {
    attrs: {
      "to": "demo-tour"
    }
  }, [_vm._v("VR Tour")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "demos-pages"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-223dbf78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demos/App.vue
// module id = 325
// module chunks = 1